import { ReactNode } from 'react';
import { BooleanLike, Case, Switch, When } from 'react-if';
import { CheckSmallCircleIcon, CrownFillIcon, CrownIcon } from '@zep/icons';
import S from './SpaceThumbnail.module.scss';
const Badge = (props: SpaceThumbnailBadgeProps) => {
  const {
    children
  } = props;
  return <span className={S.badge} data-sentry-component="Badge" data-sentry-source-file="SpaceThumbnail.tsx">{children}</span>;
};
export const SpaceThumbnail = (props: SpaceThumbnailProps) => {
  const {
    badge,
    src,
    alt,
    radioProps,
    isLazy
  } = props;
  return <div className={S.thumbnail} data-sentry-component="SpaceThumbnail" data-sentry-source-file="SpaceThumbnail.tsx">
      <When condition={badge} data-sentry-element="When" data-sentry-source-file="SpaceThumbnail.tsx">
        <Badge data-sentry-element="Badge" data-sentry-source-file="SpaceThumbnail.tsx">
          <Switch data-sentry-element="Switch" data-sentry-source-file="SpaceThumbnail.tsx">
            <Case condition={badge === 'admin'} data-sentry-element="Case" data-sentry-source-file="SpaceThumbnail.tsx">
              <CrownIcon width={16} height={16} data-sentry-element="CrownIcon" data-sentry-source-file="SpaceThumbnail.tsx" />
            </Case>
            <Case condition={badge === 'owner'} data-sentry-element="Case" data-sentry-source-file="SpaceThumbnail.tsx">
              <CrownFillIcon width={16} height={16} data-sentry-element="CrownFillIcon" data-sentry-source-file="SpaceThumbnail.tsx" />
            </Case>
          </Switch>
          <span>{badge?.toUpperCase()}</span>
        </Badge>
      </When>
      <img src={src} alt={alt} width={218} height={141} className={S.image} loading={isLazy ? 'lazy' : 'eager'} />

      <When condition={radioProps as unknown as BooleanLike} data-sentry-element="When" data-sentry-source-file="SpaceThumbnail.tsx">
        <input type="radio" className={S.control} {...radioProps} />
        <div className={S.dimmed}>
          <CheckSmallCircleIcon data-sentry-element="CheckSmallCircleIcon" data-sentry-source-file="SpaceThumbnail.tsx" />
        </div>
      </When>
    </div>;
};
type SpaceThumbnailBadgeProps = {
  children: ReactNode;
};
type SpaceThumbnailProps = {
  badge?: 'owner' | 'admin';
  src: string;
  alt: string;
  radioProps?: {
    name?: string;
    value: string | number;
  };
  isLazy: boolean;
};